import FalconComponentCard from "components/common/FalconComponentCard";
import React, { useEffect } from "react";
import { Button, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, useNavigate, useParams } from "react-router-dom";
import AddBranchForm from "./AddBranchForm";
import { GetAllPoyer } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import { CreateBranch } from "../config/branchApi";
import { toast } from "react-toastify";
import paths from "routes/paths";
import { resetIndividual } from "../config/branchSlice";
import BackButton from "components/common/custom/back-button/index";
const AddBranch = ({ view = false }) => {
  const dispatch = useDispatch();
  const { poyerList } = useSelector((state) => state.eligibilityCheckList);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch"
  );
  const {
    control,
    watch,
    setValue,
    clearErrors,
    reset,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {},
  });

  const navigate = useNavigate();

  const { id } = useParams();

  const handleReset = () => {
    reset();
  };

  // Utility function to normalize payer names

  // Normalize utility (matches camelCase or underscores, lowercased)
  const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, "");

  const handleAddBranch = async (data) => {
    const providerCodeMap = {
      provider_code_bupa: "Bupa",
      provider_code_tawuniya: "Tawuniya",
      provider_code_medgulf: "Medgulf",
      provider_code_malath: "Malath",
      provider_code_saico: "SAICO",
      provider_code_sabb: "SABB",
      provider_code_gulf_union: "Gulf Union",
      provider_code_alrajhi: "Alrajhi Takaful",
      provider_code_gig: "Gulf Insurance Group - GIG",
      provider_code_wataniyarn: "Wataniyarn",
      provider_code_medivisarn: "Medivisarn",
      provider_code_tcs: "TCS",
      provider_code_globemed: "GLOBMED",
      provider_code_nextcare: "NEXTCARE",
      provider_code_al_etihad: "AL-ETIHAD",
      provider_code_mednet: "MEDNET",
      // AL-ETIHAD is excluded (not found in payerList)
    };

    const provider_code_details = {};
    let index = 1;

    Object.entries(providerCodeMap).forEach(([key, payerName]) => {
      const code = data?.[key];
      const payer = poyerList.find((p) => p.payer_name === payerName);
      if (code && payer) {
        provider_code_details[index] = {
          provider_code: code,
          payer_id: payer.payer_id,
        };
        index++;
      }
    });

    const payload = {
      ...(id && { branch_id: id }),
      branch_name: data?.branch_name_eng || "",
      branch_arabic_name: data?.branch_name_arabic || "",
      branch_city: data?.city?.value || "",
      branch_type: "1",
      branch_address: "",
      branch_telephone: data?.mobile_no || "",
      branch_building_no: data?.building_no || "",
      branch_additional_no: data?.additional_no || "",
      branch_unit_no: data?.unit_no || "",
      branch_street_name: data?.street_name || "",
      branch_district: data?.district || "",
      branch_zip_code: data?.zip_code || "",
      branch_country: data?.country?.value || "",
      branch_vatno: data?.vat_no || "",
      branch_crno: data?.cr_no || "",
      branch_cchino: data?.cchi_no || "",
      branch_nphies_code: data?.nphies_id || "",
      provider_code_details,
    };

    const response = await dispatch(CreateBranch(payload)).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      navigate(paths.branchList);
      dispatch(resetIndividual());
    } else {
      toast.error(response?.message_en);
    }
  };

  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
  }, [poyerList]);

  return (
    <>
      {branchSetting?.add ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleAddBranch)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <BackButton
                path={paths.branchList}
                title={`${id ? (view ? "View" : "Update") : "Add"} Branch`}
              />
              <Col xs="auto m-0">
                <h5 className="text-primary mb-0 fs-10"></h5>
              </Col>
              <Col xs="auto" className="d-flex gap-2">
                {!view && (
                  <>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button type="submit" size="sm" variant="success">
                      {id ? "Update" : "Add"}
                    </Button>
                  </>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body
              style={{
                marginTop: "40px", // Adjust this value based on header height
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
              }}
            >
              <AddBranchForm
                watch={watch}
                setValue={setValue}
                errors={errors}
                control={control}
                clearErrors={clearErrors}
                isSubmitted={isSubmitted}
                view={view}
                reset={reset}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="text-center py-6">
          You don't have a permission to add Branch
        </div>
      )}
    </>
  );
};

export default AddBranch;
